import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const TransferMaterialSchema = T.Object({
  materialUuid: T.String({ format: 'uuid', error: 'UUID do material é obrigatório' }),
  targetFacilityUuid: T.String({ format: 'uuid', error: 'UUID do estabelecimento de destino é obrigatório' }),
  comments: T.Optional(T.String({ error: 'Comentários devem ser uma string' })),
});

export type TransferMaterialInputType = typeof TransferMaterialSchema.static;

export async function ValidateTransferMaterialInput(value: unknown): Promise<TransferMaterialInputType> {
  return Value.Parse(TransferMaterialSchema, value);
}

export function checkTransferMaterialInput(field: string, value: unknown): string | boolean {
  return validateField(TransferMaterialSchema, field, value);
}
